import {MutationTree} from "vuex";
import * as moment from 'moment';
import Segment from "../ts/SegmentInterface";
import IdMutationInterface from "../ts/IdMutationInterface";

export const mutations: MutationTree<any> = {

    setQueryRunning(state: any, payload: boolean) {
        state.queryRunning = payload;
    },

    setMatchCount(state: any, payload: number) {
        state.matches = payload;
    },

    setExecutionTime(state: any, executionTime: number) {
        state.executionTime = executionTime;
    },

    setResponseRate(state: any, responseRate: number) {
        state.responseRate = responseRate;
    },

    // SAMPLE DEFINITIONS
    setSegmentSaving(state: any, payload: boolean) {
        state.segmentSaving = payload;
    },

    setSegmentsLoading(state: any, payload: boolean) {
        state.segmentsLoading = payload;
    },

    setSegments(state: any, payload: Array<Segment>) {
        state.segmentsCacheExpires = moment().add(15, 'minutes');
        state.segments = payload;
    },

    newSegment(state: any, segment: Segment) {
        state.segments.push(segment);
    },

    setSegmentId(state: any, payload: IdMutationInterface) {
        let def = state.segments.find((segment: Segment) => {
            return segment.id == payload.tempId;
        });
        def.id = payload.newId;
    },

    deleteSegment(state: any, id: number) {
        let index = state.segments.findIndex((segment: Segment) => {
            return segment.id == id;
        });

        state.segments.splice(index, 1);
    },
    updateSegment(state: any, segment: Segment) {

        let def = state.segments.find((sf: Segment) => {
             return segment.id == sf.id;
        });

        def = Object.assign(def,segment);
    },
};
